import { logError, logInfo } from './logger';

export interface EventInterface {
  data: CurrentPositionEventInterface;
  [key: string]: unknown; // Allow additional properties
}

export interface CurrentPositionEventInterface {
  type: string;
  method: string;
  results: Array<number>;
}

export default class TimeManager {
  private boundEventHandler: ((event: MessageEvent) => void) | null = null;
  private startTimeStamp: number | null;
  private curTimeStamp: number | null;
  private appInstance = import.meta.env.VITE_APP_ENV;
  private catchErrorPrefix = import.meta.env.VITE_APP_CATCH_ERROR_PREFIX;
  public timeUpdateCallback: (() => void) | null = null;

  constructor() {
    this.startTimeStamp = null;
    this.curTimeStamp = null;
  }

  getDeltaFromStart() {
    if (this.startTimeStamp !== null && this.curTimeStamp !== null)
      return this.curTimeStamp - this.startTimeStamp;
    else return 0;
  }

  spoofUpdate(dt: number) {
    if (this.startTimeStamp === null) {
      this.startTimeStamp = 0;
      this.curTimeStamp = 0;
    } else {
      this.curTimeStamp = (this.curTimeStamp || 0) + dt;
    }
  }

  currentPositionEventHandler(event: MessageEvent) {
    // Type guard to ensure the event has the expected structure
    if (event.data && typeof event.data === 'object') {
      // Check if this is the direct message format from Tizen
      if (event.data.type === 'response' && event.data.method === 'updateCurrentPosition') {
        try {
          const [currentPosition, startTime] = event.data.results;
          logInfo(
            `updateCurrentPosition called with currentPosition: ${currentPosition}, startTime: ${startTime}`,
          );

          const ts = currentPosition * 0.001; // Move to seconds

          if (this.startTimeStamp === null) {
            this.startTimeStamp = ts;
          }

          this.curTimeStamp = ts;

          // Call the callback if it exists
          if (this.timeUpdateCallback) {
            this.timeUpdateCallback();
          }

          // try {
          //   // fetch(
          //   //   `${this.catchErrorPrefix}${this.appInstance}/appReachable?message_type=directTizen&CurrentPositionEventInterface=${encodeURIComponent(JSON.stringify(event.data.results))}`,
          //   // );
          // } catch (e) {
          //   logInfo(e);
          // }
        } catch (e) {
          logError(e);
        }
      }
    }
  }

  attachCurrentPositionListener() {
    // Don't reset startTimeStamp here - it should be set when the first message is received
    // Bind the event handler to ensure 'this' refers to the correct instance
    this.boundEventHandler = this.currentPositionEventHandler.bind(this);
    window.addEventListener('message', this.boundEventHandler);
  }

  detachCurrentPositionListener() {
    if (this.boundEventHandler) {
      window.removeEventListener('message', this.boundEventHandler);
      this.boundEventHandler = null;
    }
  }
}
